import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

export type FastPracovnikSelect = {
	OsobniCis?: string;
	PracovnikOzn?: string;
	UserSecondaryRole?: string;
	ProvozovnaId?: number;
	PracovnikId?: number;
	PracovnikText?: string;
	ProvozovnaIdText?: number;
};

class PracovnikProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	getPracovnikByPersonCard(personcardId: number) {
		return this.fetch(`${this.apiPath}GetPracovnikByPersonCard`, { personcardId });
	}

	resetScopePassword({ PracovnikId, Password, Scope }:
	{ PracovnikId: number, Password: string, Scope: string }) {
		return this.post(`${this.apiPath}${PracovnikId}/ResetPassword`, { Password, Scope });
	}

	passwordStatusSwitch({ PracovnikId, Active, Scope }:
	{ PracovnikId: number, Active: boolean, Scope: string }) {
		return this.post(`${this.apiPath}${PracovnikId}/Scope`, { Active, Scope });
	}

	async getTeamWorkers(workshopId: any) {
		return this.fetch(`${this.apiPath}GetTeamWorkers?workshopId=${workshopId}`);
	}

	async isUniquePersonalId(userId: number | null, personalId: string | null) {
		return this.fetch(`${this.apiPath}IsUniquePersonalId?userId=${userId}&personalId=${personalId}`);
	}
}

export const apiProvider = new PracovnikProvider();
